module.exports = __webpack_public_path__ + "images/landing/banner/social.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/banner/social.png
// module id = JfO/
// module chunks = 118